import { Center, HStack, Text, useMediaQuery } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import adBg from "../../assets/LBPortal_Graphic_AdBG.webp";
// import logo from "../../assets/taktyl_logo_1497x400px_black.webp";
import Btn from "../UI/Btn";

function LandscapeAd() {
  const [isLargerThan380] = useMediaQuery("(min-width: 380px)");
  return (
    <Center
      boxShadow='0 4px 8px #4A5568'
      mt='16px'
      mb='24px'
      // h='120px'
      // maxW='1280px'
      // for AdSense
      w={isLargerThan380 ? '970px' : '300px'}
      h={isLargerThan380 ? '90px' : '200px'}
      mx='auto'
      bgImage={adBg}
    >
      <HStack
        fontWeight='bold'
        color='black'
        fontSize='16px'
        // px={{ base: "2px", sm: "24px", md: "40px" }}
        pr={{ base: "2px", sm: "24px", md: "54px" }}
        pl={{ base: "1px", sm: "16px", md: "24px" }}
        w='100%'
        justifyContent='space-between'
      >
        {/* <Text>Taktyl Logo Here</Text> */}
        {/* <Image
          w={{ base: "120px", sm: "160px", md: "240px" }}
          src={logo}
          alt='Taktyl Logo'
        /> */}
        {isLargerThan380 && (
          <Text
            textShadow='0 0 2px white, 0 0 2px white, 0 0 2px white, 0 0 2px white'
            textAlign='center'
          >
            We do games & gamification.
          </Text>
        )}
        <Link to='/contact'>
          <Btn w={{ sm: "fit-content", md: "fit-content" }}>Contact us!</Btn>
        </Link>
      </HStack>
    </Center>
  );
}
export default LandscapeAd;
